export default "__VITE_ASSET__COAkJPW2__"